import React from "react";
import PropTypes from "prop-types";
import "./TextInput.scss";

// Input component
const TextInput = ({
  label,
  value,
  onChange,
  onPaste,
  theme,
  type,
  placeholder,
  inputMode = "text",
  step = "0.01",
  min,
  id,
  size,
  inputClass,
  disabled,
  rightIcon,
  onIconClick,
  error,
  rows = 5,
}) => {
  // Determine input field classes based on the theme, size, and type
  const strClass =
    theme === "dark"
      ? `form-control form-control-${size} bg-dark ${inputClass}`
      : `form-control form-control-${size} bg-light ${inputClass}`;

  const handleIconClick = (e) => {
    if (onIconClick) {
      onIconClick(e);
    }
  };

  return (
    <div className="input-wrapper">
      {label && <label className="form-label">{label}</label>}
      <div className="input-container">
        {type === "textarea" ? (
          <textarea
            value={[undefined, null].includes(value) ? "" : value}
            className={strClass}
            rows={rows}
            onChange={onChange}
            onPaste={onPaste}
            disabled={disabled}
          ></textarea>
        ) : (
          <input
            type={type}
            className={strClass}
            value={[undefined, null].includes(value) ? "" : value}
            onChange={onChange}
            onPaste={onPaste}
            placeholder={placeholder}
            inputMode={inputMode}
            step={step}
            min={min}
            id={id}
            disabled={disabled}
          />
        )}

        {rightIcon && (
          <div
            className="icon-wrapper"
            onClick={(e) => {
              handleIconClick(e);
            }}
          >
            {rightIcon}
          </div>
        )}
      </div>
      {error && <span style={{ color: "red" }}>{error}</span>}
    </div>
  );
};

// Default values using default parameters
const TextInputComponent = ({
  label = "",
  value = "",
  onChange = () => {},
  onPaste = () => {},
  theme = "light",
  type = "text",
  placeholder = "",
  inputMode = "",
  step="0.01",
  min = "",
  id = "",
  size = "md",
  disabled = false,
  rightIcon = null,
  onIconClick = null,
  error = "",
  inputClass
}) => {
  return (
    <TextInput
      label={label}
      value={value}
      onChange={onChange}
      onPaste={onPaste}
      theme={theme}
      type={type}
      placeholder={placeholder}
      inputMode={inputMode}
      step={step}
      min={min}
      id={id}
      size={size}
      disabled={disabled}
      rightIcon={rightIcon}
      onIconClick={onIconClick}
      error={error}
      inputClass={inputClass}
    />
  );
};

// Prop types validation
TextInputComponent.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  theme: PropTypes.oneOf(["light", "dark"]),
  type: PropTypes.string,
  placeholder: PropTypes.string,
  inputMode: PropTypes.string,
  step: PropTypes.string,
  min: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  disabled: PropTypes.bool,
  error: PropTypes.string,
  rows: PropTypes.number,
};

export default TextInputComponent;
